import { SubTipoFerramenta } from 'src/app/models/subtipoferramenta.model';
import { ToolTypeFormComponent } from './../tools-type-form/tools-type-form.component';

import { Tool } from 'src/app/models/tool.model';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { Employee } from 'src/app/models/employee.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';

import { images } from 'src/app/resources/images';
import { tools } from 'src/app/resources/tools';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { ToolSubTypeFormComponent } from '../tools-subtype-form/tools-subtype-form.component';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { TipoFerramenta } from 'src/app/models/tipoferramenta.model';
import { ApiService } from 'src/app/services/http/api.service';
import { Site } from 'src/app/models/site.model';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";

@Component({
    selector: 'app-tools-subtype-component',
    templateUrl: './tools-subtype.component.html'
})
export class ToolsSubTypeComponent implements OnInit {
    [x: string]: any;
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public gridData: SubTipoFerramenta[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];

    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService,private dialogService: DialogService,private api: ApiService,private notificationService: NotificationService) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
    }

    public ngOnInit(): void {
      this.load();
    }

    // Update Grid collection during changing My Team/All Team
    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: SubTipoFerramenta) => {
        return `${args.marca}_${args.modelo}_${args.nomeTipoFerramenta}`;
    }

      public open(): void {
        
      
        const dialogRef: DialogRef = this.dialogService.open({
        
            title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('toolsubtype') ,
          // Show component
          content: ToolSubTypeFormComponent
    
         // actions: [{ text: "Cancel" }, { text: "Delete", themeColor: "primary" }],
        });
    
        dialogRef.result.subscribe((result) => {
           
            this.gridView = this.gridData;
            this.api
            .getRequest<BaseHttpResponse<SubTipoFerramenta[]>>("SubTipoFerramenta/GetSubTiposFerramentas")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => {});
        
    
         
        });

      //  alert("showConfirmation");
       // const userInfo = dialogRef.content.instance as ProfileComponent;
        // userInfo.name = "admin";
        // userInfo.age = 42;
      }

      canList() {
        return User.canSubTipoFerramentasList();
      }
  
    canCreate() {
        return User.canSubTipoFerramentasCreate();
      }
  
    canDelete() {
        return User.canSubTipoFerramentasDelete();
      }
  
    canEdit() {
        return User.canSubTipoFerramentasEdit();
      }
    
  /*   canUpload() {
        return User.canFerramentasUpload();
    } */

      /*canEdit(){
        return User.canEditTools();
        }*/

      public openEdit(c:SubTipoFerramenta): void {
        
     
        const dialogRef: DialogRef = this.dialogService.open({
        
            title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('toolsubtype') ,
          // Show component
          content: ToolSubTypeFormComponent
    
         // actions: [{ text: "Cancel" }, { text: "Delete", themeColor: "primary" }],
        });
    

        const userInfo = dialogRef.content.instance as ToolSubTypeFormComponent;
        userInfo.formValue=c;
        userInfo.setFormValues();

        dialogRef.result.subscribe((result) => {
           
            this.gridView = this.gridData;
            this.api
            .getRequest<BaseHttpResponse<SubTipoFerramenta[]>>("SubTipoFerramenta/GetSubTiposFerramentas")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => {});
        
    
         
        });

      //  alert("showConfirmation");
       // const userInfo = dialogRef.content.instance as ProfileComponent;
        // userInfo.name = "admin";
        // userInfo.age = 42;
      }

      public delete(e :Site): void {

        var sim  =this.customMsgService.translate('yes');
        var nao  =this.customMsgService.translate('no');
        const dialog: DialogRef = this.dialogService.open({
            appendTo: this.container,
            title:   this.customMsgService.translate('confirmacao') ,
            content: this.customMsgService.translate('desejaRemover') ,
            actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
            width: 450,
            height: 200,
            minWidth: 250,
          });
      
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
            
            } else if (result.text == sim) {
            

                this.api.cruddelete<BaseHttpResult>('SubTipoFerramenta', e.id).
                then(res => {
                  if (res.ok) {

                    this.notificationService.show({
                        appendTo: this.container,
                        content:this.customMsgService.translate('registoApagadoComSucesso') ,
                        animation: { type: 'slide', duration: 500 },
                        position: { horizontal: 'center', vertical: 'top' },
                        type: { style: 'success', icon: true },
                        hideAfter: 2000
                    });
                
                    this.load();
                  } else {

                    this.notificationService.show({
                        appendTo: this.container,
                        content:res.message ,
                        animation: { type: 'slide', duration: 500 },
                        position: { horizontal: 'center', vertical: 'top' },
                        type: { style: 'error', icon: true },
                        hideAfter: 4000
                
                    });

                    // const sb = this.snackBar.open(res.message, "Fechar", {
                    //   verticalPosition: "top",
                    //   panelClass: ["red-snackbar"],
                    // });
                  }
                 
                }).
                catch(err => {
                //   const sb = this.snackBar.open(
                //     err,
                //     'Fechar',
                //     {
                //       verticalPosition: 'top',
                //       panelClass: ['red-snackbar']
                //     }
                //   );
                });



            }
      
          
          });
    }
    load() {
        this.api
        .getRequest<BaseHttpResponse<SubTipoFerramenta[]>>("SubTipoFerramenta/GetSubTiposFerramentas")
        .then((data) => {
            this.gridData = data.value;
            this.gridView = this.gridData;
        })
        .catch((err) => {});
    }

    public allData(): ExcelExportData {
        
      const result: ExcelExportData = {
        data: process( this.gridView,{filter: this.filter}).data,
     
      };
  
      return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
      this.filter = filter;
     this.gridData = filterBy(this.gridView, filter);
    }
}
